import {ReviewApprovedIcon} from '@github-ui/custom-icons/ReviewApprovedIcon'
import {ReviewState, type CompletedReview} from '@github-ui/dotcom-schema/types/pull_requests/v1/review_requests'

import {ForYouItem} from '../shared/ForYouItem'
import {useReviewData} from './use-review-data'

export function shouldShowReviewApproved(review: CompletedReview | null | undefined): review is CompletedReview {
  return review?.state === ReviewState.APPROVED
}

export function ReviewApproved() {
  const {data: review, queryStatus} = useReviewData()

  if (queryStatus !== 'success' || !shouldShowReviewApproved(review)) return null

  return (
    <ForYouItem
      itemId="review-approved"
      visual={{kind: 'icon', icon: ReviewApprovedIcon, tone: 'success', glyphSize: 16}}
      title="Approved"
      subText="You're all set — nothing to do."
    />
  )
}
